var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwitchLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#528AEA",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.53 6.663h11.82V5.109H3.53l2.883-2.9a.778.778 0 1 0-1.104-1.095L.561 5.886l4.748 4.771A.777.777 0 1 0 6.413 9.57L3.53 6.663zM16.966 5.109h2.331v1.554h-2.331zM20.851 5.109h1.555v1.554H20.85zM20.79 9.662a.778.778 0 0 0-1.104 1.096l2.883 2.899h-11.82v1.554h11.82l-2.883 2.906a.777.777 0 1 0 1.103 1.088l4.725-4.771-4.725-4.772zM6.863 13.657h2.332v1.554H6.863zM3.755 13.657h1.554v1.554H3.755z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchLine);
export default __webpack_public_path__ + "static/media/switch-line.0543792f5ea3c2c1f02cab54be176ae4.svg";
export { ForwardRef as ReactComponent };